module.exports = __webpack_public_path__ + "media/images/icon__checkmark--rb-dark-gray-0076bf58411c025fcf7efe8cd4a79415.png";